import React from 'react';
import styled from 'styled-components';

import {Handler, HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ClientRequiredTaggingParameter} from '../../../../../models/api/requiredTaggingModel';
import {TagListCard} from '../../requiredTagging/tagListCard';
import {RequiredTaggingEditorActions} from './hooks/useRequiredTaggingEditorState';

/*
 * Props.
 */

interface RequiredTaggingEditorTagListProps {
  tagListParam: ClientRequiredTaggingParameter;
  isEditing: boolean;
  isConflicting: boolean;
  shouldHideError: boolean;

  onUpdateTagList: HandlerOf<ClientRequiredTaggingParameter>;
  onDeleteTagList?: Handler;
  onValidation: RequiredTaggingEditorActions['onValidation'];
  onSetHiddenErrors: RequiredTaggingEditorActions['onSetHiddenErrors'];
}

/*
 * Styles.
 */

const StyledTagListCardWrapperDiv = styled.div`
  margin-bottom: 15px;
`;

/*
 * Component.
 */

export const RequiredTaggingEditorTagList: React.FC<RequiredTaggingEditorTagListProps> = (props) => {
  const {
    tagListParam,
    shouldHideError,
    onUpdateTagList,
    onDeleteTagList,
    onValidation,
    onSetHiddenErrors,
    isEditing,
    isConflicting,
  } = props;

  const onUpdateTagIds = (tagIds: ReadonlyArray<number>) => {
    // don't show name errors if the user just added a tag
    onSetHiddenErrors(tagIds.length > 0 ? [tagListParam.clientId] : []);
    onUpdateTagList({
      ...tagListParam,
      tagIds,
    });
  };

  const onUpdateName = (name: string) => {
    onSetHiddenErrors([]);
    onUpdateTagList({
      ...tagListParam,
      tagListName: name,
    });
  };

  const onUpdateIsOneTagRequired = (isOneTagRequired: boolean) => {
    onUpdateTagList({
      ...tagListParam,
      isOneTagRequired,
    });
  };

  return (
    <StyledTagListCardWrapperDiv>
      <TagListCard
        clientId={tagListParam.clientId}
        tagIds={tagListParam.tagIds}
        name={tagListParam.tagListName}
        isOneTagRequired={tagListParam.isOneTagRequired}
        isEditing={isEditing}
        isConflicting={isConflicting}
        onTagIdsChange={onUpdateTagIds}
        onNameChange={onUpdateName}
        onIsOneTagRequiredChange={onUpdateIsOneTagRequired}
        onCancel={onDeleteTagList}
        onValidation={onValidation}
        shouldHideError={shouldHideError}
      />
    </StyledTagListCardWrapperDiv>
  );
};
